<script setup lang="ts">
defineProps({
    checkinsCount: {
        type: Number,
        required: true
    },
    changeOrder: { type: Boolean, default: true }
})

const cdnUrl = useRuntimeConfig().app.cdnURL
</script>

<template>
    <div
        class="mt-10 md:mt-0 px-4 md:px-16 lg:px-24 md:py-9 bg-white rounded-2xl flex-col justify-center items-center gap-2 md:gap-6 inline-flex"
    >
        <h3>
            {{ $t('networks.data.attendance_title') }}
        </h3>
        <NuxtImg
            class="w-72"
            :src="`${cdnUrl}/images/StationAttendance.svg`"
            :alt="$t('networks.data.attendance_title')"
            :class="{ 'order-first md:order-none': changeOrder }"
        />
        <div class="flex-col justify-start items-center gap-0.5 inline-flex">
            <span
                class="text-center text-neutral-900 text-5xl font-bold font-inter"
            >
                {{ $n(checkinsCount) }}
            </span>
            <span
                class="text-center text-zinc-500 text-base font-normal font-inter leading-tight"
            >
                {{ $t('networks.data.attendance_info') }}
            </span>
        </div>
    </div>
</template>

<style lang="scss" scoped>
h3 {
    @apply text-center text-xl md:text-2xl leading-tight md:leading-loose;
}
</style>
